export enum AddressesStep {
  MyAddresses = 'my-addresses',
  PropertyType = 'property-type',
  ConfirmAddress = 'confirm-address',
}

export enum BuildingType {
  Apartment = 'apartment',
  House = 'house',
  Office = 'office',
  Hotel = 'hotel',
}
